<p>hotel-layout-two works!</p>
